import { SubscriptionPlansTypes } from "../../../types";

export const subscriptionPlanData = {
  [SubscriptionPlansTypes.basic] : {
    pointKeys: [
      "billing.subscriptionPoints.onlineRewards",
      "billing.subscriptionPoints.giftCardRewards",
      "billing.subscriptionPoints.travelRewards",
      "billing.subscriptionPoints.celebrations",
      "billing.subscriptionPoints.airdrops"
    ],
  },
  [SubscriptionPlansTypes.enterprise] : {
    pointKeys: [
      "billing.subscriptionPoints.onlineRewards",
      "billing.subscriptionPoints.giftCardRewards",
      "billing.subscriptionPoints.travelRewards",
      "billing.subscriptionPoints.celebrations",
      "billing.subscriptionPoints.airdrops"
    ],
  }
}
